<template>
  <div :ref="`menuWrapper-${unique}`" class="menu">
    <slot name="top"></slot>
    <slot name="toggler">
      <v-btn v-if="btnType === 'text'" @click.stop="toggle" :class="[btnClass, {'toggler--disabled': disabled}]">{{ btnText }}</v-btn>
      <v-btn v-else @click.stop="toggle" :class="[btnClass, {'toggler--disabled': disabled}]" icon>
        <v-icon>{{ btnIcon }}</v-icon>
      </v-btn>
    </slot>
  <transition name="dropdown-content">
    <div
      v-if="active"
      class="absolute py-2 px-2 content"
    >
      <slot/>
    </div>
  </transition>
  </div>
</template>

<script>
export default {
  name: "DropDownMenu",
  props: {
    btnType: {
      type: String,
      default: 'text',
    },
    btnText: {
      type: String,
      default: 'Activar',
    },
    btnIcon: {
      type: String,
      default: '',
    },
    btnClass: {
      type: Object,
      default: {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$root.$on('closeOtherMenus', (currentMenuId) => {
      if (currentMenuId !== this.unique) {
        this.active = false;
      }
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    unique() {
      return this._uid;
    },
  },
  methods: {
    toggle(){
      if (!this.disabled) {
        this.active = !this.active;
        this.$root.$emit('closeOtherMenus', this.unique);
        if (this.active) {
          document.addEventListener('click', this.handleClickOutside);
        } else {
          document.removeEventListener('click', this.handleClickOutside);
        }
      }
    },
    handleClickOutside(event) {
      if (!this.$refs[`menuWrapper-${this.unique}`].contains(event.target)) {
        this.active = false;
        document.removeEventListener('click', this.handleClickOutside);
      }
    }
  },
};
</script>

<style scoped>
.absolute {
  position: absolute;
}
.toggler--disabled {
  box-shadow: none !important;
  pointer-events: none !important;
}
/* .relative {
  position: relative;
  padding: 0;
  margin: 0;
} */
.dropdown-content-enter-active,
.dropdown-content-leave-active {
  transition: all 0.2s;
}
.dropdown-content-enter,
.dropdown-content-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
.content {
  z-index: 10;
  background-color: bisque;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 6px;
  box-shadow: 0px 0px 15px -2px #9e9e9e;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width:max-content;
  width: 160px;
  font-size: 16px;
}
.menu{
  margin-top: 0;
  padding-top: 0;
  max-width:max-content;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DropMenu.vue